<template>
    <div>
        <ContactlistComponent />
    </div>
</template>
  
<script>
import ContactlistComponent from '@/components/ContactlistComponent.vue';

export default {
    components: {
    ContactlistComponent
},
};
</script>